import {Box, Stack, Typography} from "@mui/material";
import {PhotoPreviewCard} from "./PhotoPreviewCard";
import {EffectType} from "../shared/types/EffectType";
import {GenerationTypeEnum} from "../shared/types/GenerationTypeEnum.ts";
import {IOtherPrompts} from "../app/store/slices/generationSlice.ts";
import {InputFeature} from "../features/InputFeature.tsx";
import {useMemo} from "react";
import {useIsReadyToGenerate} from "../entities/hooks/useIsReadyToGenerate.ts";
import {InputEnum} from "../shared/types/EffectType.ts";
import {CustomEffectPreviewWidget} from "./CustomEffectPreviewWidget.tsx";
import {GenerateButton} from "../shared/ui/GenerateButton.tsx";

interface IConfirmGenerationWidgetProps {
    uploadedPhotoSrc: string;
    effect: EffectType;
    onGenerateClick: () => void;
    onChangePhoto: () => void;
    onChangeEffect: () => void;
    textPromptInput?: IOtherPrompts | undefined;
}

export const ConfirmGenerationWidget = ({
                                            uploadedPhotoSrc,
                                            effect,
                                            onGenerateClick,
                                            onChangePhoto,
                                            onChangeEffect,
                                            textPromptInput,
                                        }: IConfirmGenerationWidgetProps) => {
    const isReadyToGenerate = useIsReadyToGenerate();

    const hasPrefilledPrompt = useMemo(() => {
        const textInput = effect.inputs.find((i) => i.type === InputEnum.TextPrompt);
        return !!textInput?.prompt;
    }, [effect]);


    return (
        <Box sx={{padding: '24px 16px'}}>
            <Typography variant="h6" sx={{textAlign: 'center', marginBottom: '8px'}}>
                {effect.title}
            </Typography>
            <Typography variant="body2" sx={{textAlign: 'center', marginBottom: '24px', opacity: 0.7}}>
                {effect.description}
            </Typography>
            <Stack direction="row" spacing={2} justifyContent="center" alignItems="flex-end"
                   sx={{marginBottom: '24px', width: '100%', overflow: 'hidden'}}>
                <PhotoPreviewCard
                    mediaType={GenerationTypeEnum.IMAGE}
                    imageSrc={uploadedPhotoSrc}
                    type="initial"
                    onChangeClick={onChangePhoto}
                />
                {effect.isCustom ? (
                    <CustomEffectPreviewWidget
                        mediaType={effect.mediaType}
                        title={effect.title}
                        price={effect.price}
                        onChangeClick={onChangeEffect}
                    />
                ) : (
                    <PhotoPreviewCard
                        mediaType={effect.mediaType}
                        imageSrc={effect.imgSrc ?? '/default.webp'}
                        type="effect"
                        onChangeClick={onChangeEffect}
                    />
                )}
            </Stack>
            {!hasPrefilledPrompt &&
                <InputFeature input={textPromptInput} />}
            <GenerateButton
                price={effect.price}
                disabled={!isReadyToGenerate}
                onClick={onGenerateClick}
            />
        </Box>
    );
};
